// extracted by mini-css-extract-plugin
export default {"ProductPageCont":"ProductPage_ProductPageCont__FN6Ud","ProductPage":"ProductPage_ProductPage__hV23U"};